var s=(r=>(r.PENDING="pending",r.SUCCESS="success",r.ERROR="error",r))(s||{});export{s as PictureStatus};
